import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { testimonials } from './data';
import '../assests/CSS/testimonial.css';

function Testimonial() {
  const [current, setCurrent] = useState(0);
  const contentRef = useRef(null);
  const [maxHeight, setMaxHeight] = useState(250);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 767);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % testimonials.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (contentRef.current) {
      const height = contentRef.current.offsetHeight;
      setMaxHeight((prev) => Math.max(prev, height));
    }
  }, [current]);

  return (
    <div className="testimonial-container">
      <div className="left-section">
        <h4>TESTIMONIAL</h4>
        <h2>Verified Client Reviews</h2>
        {/*  desktop/tablet */}
        {!isMobile && <button className="join-button">Join us</button>}
      </div>

      <div className="right-section">
        <div className="testimonial-content dynamic-height" style={{ '--dynamic-height': `${maxHeight}px` }}>
          <AnimatePresence mode="wait">
            <motion.div
              key={current}
              className="testimonial-card"
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -20 }}
              transition={{ duration: 0.6 }}
              ref={contentRef}
            >
              <p>{testimonials[current].testimonial}</p>
              <div className="client-info">
                <img
                  src={testimonials[current].image}
                  alt={testimonials[current].name}
                  className="client-photo"
                />
                <div>
                  <h3 className="client-name">{testimonials[current].name}</h3>
                  <p className="client-role">{testimonials[current].role}</p>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>

       
        <div className="dot-indicator">
          {testimonials.map((_, idx) => (
            <span key={idx} className={`dot ${idx === current ? 'active' : ''}`}></span>
          ))}
        </div>
         {/* mobile */}
        {isMobile && <button className="join-button">Join us</button>}

      </div>
    </div>
  );
}

export default Testimonial;
